"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.SEARCH_BOX_SOURCE = exports.DEFAULT_COLLAPSED_WIDTH = exports.DEFAULT_EXPANDED_WIDTH = void 0;

var _stylingConstants = require("../../styling/stylingConstants");

var DEFAULT_EXPANDED_WIDTH = 928;
exports.DEFAULT_EXPANDED_WIDTH = DEFAULT_EXPANDED_WIDTH;
var DEFAULT_COLLAPSED_WIDTH = 73 * _stylingConstants.gridUnit;
exports.DEFAULT_COLLAPSED_WIDTH = DEFAULT_COLLAPSED_WIDTH;
var SEARCH_BOX_SOURCE = 'search_box';
exports.SEARCH_BOX_SOURCE = SEARCH_BOX_SOURCE;